<template>
  <div class="patients h-100">
    <div class="row no-gutters h-100 wrapper">
      <div
        class="col h-100 scroller"
        :class="{
          'pr-2 col-1 col-lg-3': $route.params.id,
        }"
      >
        <div v-if="!loading && patients.length > 0" class="list-group">
          <router-link
            v-for="(item, index) in patients"
            :key="index"
            :to="`/patients/${index}`"
            class="list-group-item list-group-item-action"
            :class="{active: $route.params.id === item.clinic_patient.id}"
          >
            <div class="row no-gutters">
              <div class="col-auto mr-2">
                <div
                  :style="{
                    backgroundImage: `url(${staticUrl}${item.clinic_patient.photo})`,
                  }"
                  class="avatar"
                ></div>
              </div>
              <div class="col">
                <div class="d-flex w-100 justify-content-between">
                  <h5 class="mb-1">
                    {{ item.clinic_patient.firstname[authLocale] }}
                    {{ item.clinic_patient.lastname[authLocale] }}
                    <small class="d-block">
                      {{ item.schedules.length }} {{ $t('services')}}
                    </small>
                  </h5>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <template v-if="($route.params.id && patients[$route.params.id])">
        <div class="panel col-lg pl-lg-2">
          <CaseManagerPanel
            :patient.sync="patients[$route.params.id]"
          ></CaseManagerPanel>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import CaseManagerPanel from '@/components/Panel/CaseManager/Index.vue'
export default {
  components: {
    CaseManagerPanel
  },
  data () {
    return {
      loading: false,
      patients: []
    }
  },
  computed: {
    ...mapGetters({
      type: 'auth/type',
      chats: 'chat/chats',
      chatById: 'chat/byId',
      staticUrl: 'app/staticUrl',
      authLocale: 'auth/locale'
    })
  },
  mounted () {
    this.refreshHeight()
    this.fetch()
  },
  methods: {
    ...mapMutations({
      refreshHeight: 'app/refreshHeight',
      setError: 'alert/setError'
    }),
    async fetch () {
      try {
        const response = await this.axios.get('/api/clinic/patients/with-pending-schedules')
        this.patients = response.data.data
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<i18n>
{
  "ka": {
      "services": "სერვისი"
  }
}
</i18n>
